import { render, staticRenderFns } from "./EmpresaEstab.vue?vue&type=template&id=c4292738&"
import script from "./EmpresaEstab.vue?vue&type=script&lang=js&"
export * from "./EmpresaEstab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports